<div class="ai-chat-image-preview">
  <!-- Same cross as the chat panel's close control - one box, one 1.6 stroke - so the pair of
       Pebbl dialogs close with the same glyph. -->
  <button class="ai-chat-image-preview-close" type="button" (click)="activeModal.dismiss()"
    aria-label="Close image preview" ngbTooltip="Close" placement="bottom" container="body">
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor"
      stroke-width="1.6" stroke-linecap="round" aria-hidden="true">
      <path d="M3 3 13 13M13 3 3 13" />
    </svg>
  </button>
  <!-- The attributes are a nominal 4:3 so the box exists before the bytes arrive; the real
       proportions are unknowable here (any screenshot, any camera), so the CSS lets the height
       follow the image once it loads. -->
  <img class="ai-chat-image-preview-img" [src]="imageUrl" [alt]="imageName" width="1200"
    height="900" appHandleImageError loading="eager">
  <!-- Labels the dialog (ariaLabelledBy in openAttachmentPreview) as well as the image. -->
  <p class="ai-chat-image-preview-name" id="ai-chat-image-preview-name">{{ imageName }}</p>
</div>
